import React, { ReactNode } from 'react';
import styled from 'styled-components';

export interface PanelProps {
  isLoading?: boolean;
  header?: ReactNode | string;
  children: ReactNode;
}

const PanelStyle = styled.section`
  background-color: white;
  color: #475f7b;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.12);
`;

const Header = styled.div`
  height: 50px;
  padding: 10px 25px 10px;
  /* border-bottom: 1px solid #f1f1f1; */
`;
const List = styled.ul`
  list-style-type: none;
  padding: 20px;
  > li {
    font-size: 1.2em;
    padding: 0.3em;
  }
`;

export function Panel(props: PanelProps) {
  if (props.isLoading) {
    return <PanelStyle>loading ...</PanelStyle>;
  }
  return (
    <PanelStyle>
      <Header>
        <h3>{props.header}</h3>
      </Header>
      <List>{props.children}</List>
    </PanelStyle>
  );
}
